import React from "react";
import styled from "styled-components";

import colorBar from "images/v3/icons/color_bar.svg";

const Wrapper = styled.div`
	margin-bottom: 30px;
	padding: 0 10px;
`;

/* const Title = styled.h2`
	margin: 0;
	color: #01788a;
	text-transform: uppercase;

	@media (max-width: 576px) {
		text-align: center;
	}
`; */

const Separator = styled.div`
	border-top: 1.5px solid #b6b6b6;
	position: relative;
	margin: 0;
`;

const ColorBar = styled.img`
	width: 37px;
	height: 8px;
	position: absolute;
	top: -1.5px;
	left: -5px;

	@media (max-width: 576px) {
		left: calc(50% - 37px / 2);
	}
`;

const SectionHeading = ({ title, children }) => (
	<Wrapper>
		<h2 className="TGh2">{children}</h2>
		<Separator>
			<ColorBar src={colorBar} />
		</Separator>
	</Wrapper>
);

export default SectionHeading;
